// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"bfee896f","navBarContainer":"fc319f3d","navBarGroup":"b19b0b1b","logo":"a36c5c9e","faded":"be40d300"};